import type {PartiallyRequired} from '@wix/devzai-utils-common';
import {hideableValueCreateHidden} from '@wix/devzai-utils-common';
import {
    DoppeActionLayout,
    doppeListActionGetDefaultListSettings,
    doppeListActionGetDefaultSearchListSettings,
    doppeListActionGetItemClickBehaviourDefaultListSettings,
    doppeListActionGetMainDetailsDefaultSettings,
    doppeListActionListItemSettingsMigrateBaseSettings,
    doppeListActionListItemWithCtaButtonsMigration,
    doppeListActionListItemWithSectionsMigration,
    doppeListActionTemplateCtaButtonsSettingsDefaultValuesMigration,
    doppeListActionTemplateSectionsSettingsDefaultValuesMigration
} from '../../client-server-common';


import {DoppeActionTypeTestimonialsList} from './doppe-action-type-testimonials-list';

export function doppeActionTypeTestimonialsListResolveListItemSettings(testimonial: PartiallyRequired<DoppeActionTypeTestimonialsList.TestimonialItemSettings, 'id'>) {

    const {
        name = '',
        tagLine = hideableValueCreateHidden(''),
        date = hideableValueCreateHidden(''),
        mainQuote = hideableValueCreateHidden(''),
        description = '',
        profileMedia = null,
        rating = hideableValueCreateHidden(5 as const),
        ribbon = hideableValueCreateHidden(''),
        ...restTestimonial
    } = testimonial;

    return {
        ...restTestimonial,
        ...doppeListActionListItemSettingsMigrateBaseSettings(testimonial),
        name: name,
        tagLine: tagLine,
        date: date,
        mainQuote: mainQuote,
        description: description,
        profileMedia: profileMedia,
        rating: rating,
        ribbon: ribbon,
        ...doppeListActionListItemWithCtaButtonsMigration(testimonial, false),
        ...doppeListActionListItemWithSectionsMigration(testimonial),
    }
}

export function doppeActionTypeTestimonialsListResolveActionSettings(actionSettings: Partial<DoppeActionTypeTestimonialsList.ActionSettings>) {
    const {
        listDataItems = [],
        itemShowRating = true,
        previewShowDescription = true,
        layout = DoppeActionLayout.Column,
        ...restSettings
    } = actionSettings;

    return {
        ...restSettings,
        itemShowRating: itemShowRating,
        previewShowDescription: previewShowDescription,
        ...doppeListActionGetItemClickBehaviourDefaultListSettings(actionSettings),
        ...doppeListActionGetMainDetailsDefaultSettings({}, actionSettings),
        ...doppeListActionGetDefaultSearchListSettings(actionSettings),
        ...doppeListActionGetDefaultListSettings<DoppeActionTypeTestimonialsList.TestimonialItemSettings>({
            ...actionSettings,
            layout: layout,
            listDataItems: listDataItems.map(doppeActionTypeTestimonialsListResolveListItemSettings),
        }),
        ...doppeListActionTemplateCtaButtonsSettingsDefaultValuesMigration(actionSettings, false),
        ...doppeListActionTemplateSectionsSettingsDefaultValuesMigration(actionSettings),
    } satisfies DoppeActionTypeTestimonialsList.ActionSettings;
}